import { GET, POST, PATCH, DELETE } from './HTTPClient'
const HTTPClient = { GET, POST, PATCH, DELETE }

export {
    HTTPClient
}